import React from "react";
import { House } from "lucide-react";

/**
 * Neutral placeholder for property photos.
 * Renders a dashed frame with a house icon and "Foto pendente" label.
 */
export default function HouseImagePlaceholder({ className = "", label = "Foto pendente", ratio = "aspect-[4/3]" }) {
  return (
    <div
      data-testid="house-image-placeholder"
      className={`${ratio} w-full bg-[#F7F4EF] border-2 border-dashed border-[#0AA89C]/25 flex flex-col items-center justify-center text-[#066B63]/50 select-none ${className}`}
    >
      <House className="w-10 h-10 mb-2" />
      <span className="text-xs uppercase tracking-[0.24em] font-medium">{label}</span>
    </div>
  );
}
